import { ICalculatorBag } from "../ts/rustmix-buyer.types";

export const loadBagsDataToLocalStorage = ({ setBagA, setBagB, setResData }: IArgs) => {
    const localA = localStorage.getItem('bagA');
    if (localA) setBagA(JSON.parse(localA));
    const localB = localStorage.getItem('bagB');
    if (localB) setBagB(JSON.parse(localB));
    const localResult = localStorage.getItem('resData');
    if (localResult) setResData(JSON.parse(localResult));
}

interface IArgs {
  setBagA: (value: ICalculatorBag) => void;
  setBagB: (value: ICalculatorBag) => void;
  setResData: (value: ICalculatorBag) => void;
}

